import { Suspense } from '@/components/ui/Suspense'
import { CheckPermission, Permission } from '@/features/auth'
import { BrandingForm } from '@/features/branding'

function Branding() {
  return <BrandingForm />
}

export default function BrandingSuspense() {
  return (
    <CheckPermission
      permissions={[Permission.BRANDING_UPDATE]}
      redirect={'/goodies'}
    >
      <Suspense isFullPage>
        <Branding />
      </Suspense>
    </CheckPermission>
  )
}
